import { createFileRoute, redirect } from '@tanstack/react-router';
import { RoadmapPage } from '@/components/roadmap';
import { requireSession } from '@/lib/route-guards';

// Network-leader roadmap board. Gated on the server-evaluated
// `canViewRoadmap` capability from /me/context (Network leaders of an active
// Network + platform admins); everyone else lands back on /feed. The server
// enforces the same predicate on every roadmap route regardless.
export const Route = createFileRoute('/_authed/roadmap/')({
  beforeLoad: async ({ context }) => {
    const ctx = await requireSession(context);
    if (!ctx.capabilities.canViewRoadmap) throw redirect({ to: '/feed' });
  },
  component: RoadmapPage,
});
